import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { DSNotification, DSLinkButton, NotificationVariant } from '@stihl-design-system/components';

import { useCustomerSupportLink } from '../use-customer-support-link';

interface CustomerSupportAlertProps {
  message: string;
  type?: NotificationVariant;
  serialNumber?: string;
  className?: string;
}

export const CustomerSupportAlert: FC<CustomerSupportAlertProps> = ({ message, type, serialNumber, className }) => {
  const { t: tShared } = useTranslation('shared');

  const customerSupportLink = useCustomerSupportLink('tool', serialNumber);

  return (
    <DSNotification
      variant={type}
      className={className}
      customActionArea={
        <DSLinkButton href={customerSupportLink} variant="outline" size="small">
          {tShared('shared_customerSupport')}
        </DSLinkButton>
      }
      data-testid="customer-support-alert"
    >
      {message}
    </DSNotification>
  );
};
